import { useCallback } from 'react';
import { LINK_CLICKS_ACCESS_STATUSES } from '../redux/slices/mePageData';
import requestFromParent from '../utils/requestFromParent';

const LINK_CLICKS_ACCESS_REQUEST = 'GET_LINK_CLICKS_ACCESS_STATUS';

const isValidAccessStatus = (status) =>
  Object.values(LINK_CLICKS_ACCESS_STATUSES).includes(status);

const useLinkClicksAccess = () => {
  const getLinkClicksAccessStatus = useCallback(async () => {
    try {
      const { linkClicksAccessStatus } = await requestFromParent(
        LINK_CLICKS_ACCESS_REQUEST
      );

      if (!isValidAccessStatus(linkClicksAccessStatus)) {
        throw new Error('Invalid link clicks access status');
      }

      return linkClicksAccessStatus;
    } catch (error) {
      console.error('Link clicks access request failed', error);

      return LINK_CLICKS_ACCESS_STATUSES.PREMIUM_REQUIRED;
    }
  }, []);

  return { getLinkClicksAccessStatus };
};

export default useLinkClicksAccess;
